export default __webpack_public_path__ + "static/media/06AW1NOV65.3f505329.jpg";